const USPhoneFormat = (phoneNumber: string) =>
  `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`

export { USPhoneFormat }
